'use client';

import React, { createContext, useContext, ReactNode } from 'react';
import { useSocket } from '../hooks/useSocket';
import { useSession } from '@descope/react-sdk';

// Define the shape of context value
export type SocketContextType = {
  isConnected: boolean;
  emit: (event: string, data: any, callback?: (response: any) => void) => void;
  on: (event: string, callback: (data: any) => void) => () => void;
};

// Create context with default values
const SocketContext = createContext<SocketContextType | null>(null);

// Create provider component
export const SocketProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { sessionToken } = useSession();
  const token = sessionToken;
  const socketUrl = process.env.NEXT_PUBLIC_WEBSOCKET_URL || 'http://localhost:6060';
  const socket = useSocket(socketUrl, token);

  return (
    <SocketContext.Provider value={socket}>
      {children}
    </SocketContext.Provider>
  );
};

// Create hook for using the context
export const useSocketContext = () => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error('useSocketContext must be used within a SocketProvider');
  }
  return context;
}; 